<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{ sTituloGrid }}</span>
      </v-col>
    </v-row>
    <v-row class="no-gutters">
      <v-col md="12" sm="12">
        <div class="under-sec-flat-gray mt-1">
          <v-slide-group class="pa-1" show-arrows>
            <v-slide-item
              v-for="(itemProgress, idx) in aItemsProgressEstados"
              :key="'itemProgress' + idx"
            >
              <ProgressCircular
                :key="nRefresProgressCircular"
                :progresoTotal="itemProgress.valorTotal"
                :progresoActual="itemProgress.valorActual"
                :titulo="itemProgress.titulo"
                :idEvento="itemProgress.idEvento"
                @filtrar="onFiltrarEstado"
                :class="{'inactivo' : bProgessEstado[idx]}"
              />
            </v-slide-item>
          </v-slide-group>
        </div>
        <grid
        ref="gestionpqr"
          v-if="this.$store.state.token != ''"
          :key="nRefreshGestionPqr"
          :tabla="sTablaName"
          :bActiveFilter="true"
          :bActiveExport="true"
          :bSingleSelect="true"
          :bShowSelect="false"
          :sIdTable="'idRequerimiento'"
          :aAccionesAdicionales="aAccionesAdicionales"
          :bShowMapDetails="false"
          :aInfoTBDetalleExp="aDetallesExport3"
          :bActiveNew="false"
          @idSelect="getIdSelect"
          @nameField="getNameFieldSelect"
          @oItemSeleccionado="getItemSeleccionado"
          @onBtnEditarSac="onAccionEvento"
          @onBtnAgregarObs="onAccionEvento"
          @onBtnDinamico="onAccionEvento"
          @filtrando="onRefrescarItems"
          :aParametros.sync="aFiltroParametros"
          altoTabla="43vh"
          />
          <!-- @refrescarItems="onRefrescarItems" -->
        <v-dialog
          v-model="bMostrarModal"
          persistent scrollable 
          max-width="680px"
        >
          <v-card class="pa-0">
            <v-toolbar
              color="headformsdark"
              height="45"
              elevation="0"
              dense
              dark
            >
              <v-spacer></v-spacer>
              <span class="mdlHeadForms">{{$store.state.jsIdioma.oEquivalencias.ttlGestionarPQR}}</span>
              <v-spacer></v-spacer>
              <v-btn
                color="btncolor-dark"
                @click="bMostrarModal = false"
                icon
                small
                dark
                outlined
              >
                <v-icon size="14px">fa fa-times</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-1 ma-0" style="max-height: 80vh;">
              <GestionarPQR 
              :aParametros="aFiltroParametros"
              :oData="oItemSeleccionado"
              :oDetalleFormulario="oDetalleFormulario"
              @onCancelarFormulario="bMostrarModal = false"
              @onCerrarFormulario="onRefrescarItems(),onDescargarEstados(),nRefreshGestionPqr++"
              v-if="bMostrarModal"/>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
      <EditarTicket ref="rEditarTicket" @onSuccessEdit="onSuccessEdit" />
      <AgregarObservacion
        ref="rAggObservacion"
        @onCerrarAgregar="onCerrarAgregar"
      />
    </v-row>
  </v-container>
</template>

<script>
import grid from "@/components/Grid/Grid.vue";
import ProgressCircular from "@/components/Seif/riesgos/CircularProgress.vue";
import mxFunciones from "@/mixins/funciones.js";
import axiosServices from "@/services/axiosServices.js";
import GestionarPQR from "@/views/Pqr/Configuracion/FormGestionPqr.vue";

// nuevas acciones
import EditarTicket from "@/views/sac/formularios/EditarTicket.vue";
import AgregarObservacion from "@/views/sac/formularios/AgregarObservacion.vue";
import { mapGetters } from 'vuex';

export default {
  name: "GestionPQR",
  components: {
    grid,
    ProgressCircular,
    GestionarPQR,
    EditarTicket,
    AgregarObservacion
  },
  mixins: [mxFunciones],
  data() {
    return {
      sTituloGrid: "", // titulo de la grid
      sTablaName: "V_PQR_Gestion$1", // Nombre de la tabla a trabajar Plan de tratamiento *Cambiar 6
      sIdTable: "idRequerimiento",
      nIdSeleccionado: 0,
      nRefreshGestionPqr: 0,
      aDetallesExport3: [],
      sNombreCampoFiltro: "",
      aItemsProgressEstados: [], // Valores del progreso
      btnActiveBySelect: true,
      nRefresProgressCircular: 0,
      aFiltroParametros: [
        `idEstado=`,
        `sPqrPerfil=${this.$store.state.sIdPqrPerfil}`,
        `sDepcia=${this.$store.state.sDependencias}`,
        `sDepto=${this.$store.state.idDeparment}`,
        `sTipoReq=`,
      ],
      aAccionesAdicionales: [
        {
          componente: "BtnAgregarObs",
          mensaje: "Agregar observación",
          oProps: {
            sNombre: "agregarObservacion",
            sTablaFormulario: "PQR_Requerimientos",
            sDetalleTitulo: "Información de PQR",
            bDetalleFormulario: true,
          },
        },
      ],
      bMostrarModal: false,
      oItemSeleccionado: {},
      oDetalleFormulario: {},
      bFiltroActivo: false,
      bProgessEstado: [],
      sFiltroGrid:''
    };
  },
  async mounted() {
    this.onValidarTokenSinLogin();
    this.onDescargarEstados();
    this.sTituloGrid = await this.getTitulo(this.sTablaName);
  },
  methods: {
    async onRefrescarItems(oFiltros = ''){
      const sFiltro = ((oFiltros === undefined || oFiltros === null || oFiltros =='') ?  `` : `filtros=${JSON.stringify(oFiltros.oParamsFiltro)}`)
      this.sFiltroGrid = sFiltro
      this.onDescargarEstados(sFiltro)
    },
    onSuccessEdit({ sStatus, sMessage }) {
      this.$swal({
        timer: 1500,
        icon: `${sStatus}`,
        title: `${sMessage}`,
        showConfirmButton: false,
      });
      const rEditar = this.$refs.rEditarTicket;
      rEditar.bMostrar = false;
      this.nRefreshGestionPqr++;
    },
    onCerrarAgregar() {
      const rEditar = this.$refs.rAggObservacion;
      rEditar.bMostrar = false;
      setTimeout(() => {
        this.onDescargarEstados();
        this.nRefreshGestionPqr++;
        this.nRefresProgressCircular++;
      }, 1000);
    },
    onAccionEvento(oItem, sAccion, oDetalleFormulario) {
      oDetalleFormulario
      const rEditar = this.$refs.rEditarTicket;
      const rAggObservacion = this.$refs.rAggObservacion;
      // capturamos el id del registro
      const { idRequerimiento } = oItem;
    
      switch (sAccion) {
        // Case para Editar ticket
        case "editarTicket":
          rEditar.bMostrar = true;
          rEditar.idRequerimiento = idRequerimiento;
          // Ejecutamos la función onGetForm del componente EditarTicket
          rEditar.onGetForm();
          break;
        // Case para agregar observacion
        case "agregarObservacion":
          rAggObservacion.bMostrar = true;
          // asignamos el id
          rAggObservacion.idRequerimiento = idRequerimiento;
          rAggObservacion.onInit();
          break;
      }
    },
    onFiltrarEstado(sId) {
      this.bProgessEstado = Array(this.aItemsProgressEstados.length).fill(true)
      this.bFiltroActivo =! this.bFiltroActivo
      if((sId-1) >= 0){
        this.$set(this.bProgessEstado, (sId-1), false)
      }else {
        this.bProgessEstado = Array(this.aItemsProgressEstados.length).fill(false)
      }
      if(this.bFiltroActivo) {
        this.aFiltroParametros[0] = `idEstado=${Math.abs(sId)}`;
        this.onDescargarEstados(this.sFiltroGrid);
        //this.nRefreshGestionPqr++;
      }else{
        this.aFiltroParametros[0] = `idEstado=`;
        this.onDescargarEstados(this.sFiltroGrid);
        //this.nRefreshGestionPqr++;
      }
      // usamos la referencia de la grid para acceder a la variable filtradoEstate y asignarle true
      // de la misma manera accedemos a onRegrescarItems
      // de esta forma no se reestablecen los filtros de la grid
      const rGrid = this.$refs.gestionpqr;
      //rGrid.filtradoEstate = true;
      rGrid.onRefrescarItems();
    },
    async onDescargarEstados(sFiltro = '') {
      const state = this.$store.state;
      const sParams = `sPqrPerfil=${this.$store.state.sIdPqrPerfil}&sDepcia=${state.sDependencias}&sDepto=${state.idDeparment}&sNameTable=${this.sTablaName}&sFiltroClientes=${state.idCliente}&${sFiltro}`;
      const { aData } = await axiosServices.getConfiguration("/pqr/estados", true, sParams);
      this.aItemsProgressEstados = aData;
      this.bMostrarModal = false;
    },
    getIdSelect(sIdSelected) {
      this.nIdSeleccionado = sIdSelected;
    },
    getNameFieldSelect(sNameFiled) {
      this.sNombreCampoFiltro = sNameFiled;
    },
    getItemSeleccionado(oItemSeleccionado) {
      this.btnActiveBySelect = !this.btnActiveBySelect;
      this.oItemSeleccionado = oItemSeleccionado;
    },
  },
  computed: {
    ...mapGetters("filterSeccion", ["getaInfoFiltrada", "getoParamsFiltro"]),
  }
};
</script>
<style lang="scss" scoped>
.inactivo{
  opacity: 0.3;
  pointer-events: none!important;
}
</style>